__turbopack_context__.v({
  "active": "style-module-scss-module__IWaEwa__active",
  "address-page-icon": "style-module-scss-module__IWaEwa__address-page-icon",
  "burst": "style-module-scss-module__IWaEwa__burst",
  "burstDot": "style-module-scss-module__IWaEwa__burstDot",
  "burstRing": "style-module-scss-module__IWaEwa__burstRing",
  "burstVariant": "style-module-scss-module__IWaEwa__burstVariant",
  "component": "style-module-scss-module__IWaEwa__component",
  "dash": "style-module-scss-module__IWaEwa__dash",
  "dash-check": "style-module-scss-module__IWaEwa__dash-check",
  "exp": "style-module-scss-module__IWaEwa__exp",
  "favourite": "style-module-scss-module__IWaEwa__favourite",
  "favourite-wrapper": "style-module-scss-module__IWaEwa__favourite-wrapper",
  "favouriteBurstDot": "style-module-scss-module__IWaEwa__favouriteBurstDot",
  "favouriteBurstRing": "style-module-scss-module__IWaEwa__favouriteBurstRing",
  "favouriteBurstTravel": "style-module-scss-module__IWaEwa__favouriteBurstTravel",
  "favouriteHeartPop": "style-module-scss-module__IWaEwa__favouriteHeartPop",
  "fillWhite": "style-module-scss-module__IWaEwa__fillWhite",
  "heartLayer": "style-module-scss-module__IWaEwa__heartLayer",
  "heartPop": "style-module-scss-module__IWaEwa__heartPop",
  "icon-spin": "style-module-scss-module__IWaEwa__icon-spin",
  "pride": "style-module-scss-module__IWaEwa__pride",
  "progressBarStripes": "style-module-scss-module__IWaEwa__progressBarStripes",
  "pulsateScale": "style-module-scss-module__IWaEwa__pulsateScale",
  "shimmer": "style-module-scss-module__IWaEwa__shimmer",
  "small-card": "style-module-scss-module__IWaEwa__small-card",
  "smallPulsateScale": "style-module-scss-module__IWaEwa__smallPulsateScale",
  "spin": "style-module-scss-module__IWaEwa__spin",
  "spinner": "style-module-scss-module__IWaEwa__spinner",
  "spinnerWrapper": "style-module-scss-module__IWaEwa__spinnerWrapper",
});
